import { expectJson } from "./http"

/**
 * How the runtime took a reply to a question, secret request, or permission ask. "closed" means the ask no
 * longer waits for one: it was answered elsewhere, dismissed, or withdrawn when its chat stopped, which the
 * runtime reports as 404 (no such waiting ask) or 410 (expired).
 */
export type RequestReply = "answered" | "closed"

export async function requestReply(response: Response, unacknowledged: string): Promise<RequestReply> {
  if (response.status === 404 || response.status === 410) return "closed"
  await expectJson(response, (value) => {
    if (value !== true) throw new Error(unacknowledged)
    return value
  })
  return "answered"
}
